import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Training|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryTraining';
export type SPCandidateHistoryTrainingLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelActiveDate`
	| `${LocNameStart}LabelExpireDate`
	| `${LocNameStart}LabelUpdated`
	| `${LocNameStart}LabelReviewStatus`
	| `${LocNameStart}LabelInvalid`
	| `${LocNameStart}LabelDataProvider`
	| `${LocNameStart}LabelDocumentation`;

export const spCandidateHistoryTrainingLocs: LocDefs<SPCandidateHistoryTrainingLocNames> = {
	SPCandidateHistoryTrainingTitleTab: {
		defaultValue: 'Training',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Candidates.Training.Title.Tab',
		...sharedProperties,
	},
	SPCandidateHistoryTrainingTitlePage: {
		defaultValue: 'Training',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Candidates.Training.Title.PageSectionTitle',
		...sharedProperties,
	},
	SPCandidateHistoryTrainingLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Training.ColumnHeading.Name',
		...sharedProperties,
	},
	SPCandidateHistoryTrainingLabelActiveDate: {
		defaultValue: 'Active Date',
		description: 'Column heading for: Active Date.',
		displayPath: `${pathStart}Active Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Training.ColumnHeading.ActiveDate',
		...sharedProperties,
	},
	SPCandidateHistoryTrainingLabelExpireDate: {
		defaultValue: 'Expire Date',
		description: 'Column heading for: Expire Date.',
		displayPath: `${pathStart}Expire Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Training.ColumnHeading.ExpireDate',
		...sharedProperties,
	},
	SPCandidateHistoryTrainingLabelUpdated: {
		defaultValue: 'Updated',
		description: 'Column heading for: Updated.',
		displayPath: `${pathStart}Updated`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Training.ColumnHeading.Updated',
		...sharedProperties,
	},
	SPCandidateHistoryTrainingLabelReviewStatus: {
		defaultValue: 'Review Status',
		description: 'Column heading for: Review Status.',
		displayPath: `${pathStart}Review Status`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Training.ColumnHeading.ReviewStatus',
		...sharedProperties,
	},
	SPCandidateHistoryTrainingLabelInvalid: {
		defaultValue: 'Invalid',
		description: 'Column heading for: Invalid.',
		displayPath: `${pathStart}Invalid`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Training.ColumnHeading.Invalid',
		...sharedProperties,
	},
	SPCandidateHistoryTrainingLabelDataProvider: {
		defaultValue: 'Data Provider',
		description: 'Column heading for: Data Provider.',
		displayPath: `${pathStart}Data Provider`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Training.ColumnHeading.DataProvider',
		...sharedProperties,
	},
	SPCandidateHistoryTrainingLabelDocumentation: {
		defaultValue: 'Documentation',
		description: 'Column heading for: Documentation.',
		displayPath: `${pathStart}Documentation`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Candidates.Training.ColumnHeading.Documentation',
		...sharedProperties,
	},
};

export type SPCandidateHistoryTrainingLocType = LocMap<SPCandidateHistoryTrainingLocNames>;
